const RAD = Math.PI / 180;
const dir = (y, p) => [Math.cos(p * RAD) * Math.sin(y * RAD), Math.sin(p * RAD), Math.cos(p * RAD) * Math.cos(y * RAD)];

export const tourSrc = (backend, t) => (t.source === "giraffe" ? t.giraffe_url : `${backend}/api/tdv/t/${t.id}/${t.entry || "index.htm"}`);

export function tdvOf(iframe) {
  try {
    const t = iframe?.contentWindow?.tour;
    return t && t.player && t.player.getById("mainPlayList") ? t : null;
  } catch {
    return null;
  }
}

const playlist = (t) => t.player.getById("mainPlayList");

export function scenesOf(t) {
  return (playlist(t).get("items") || []).map((it, i) => {
    const m = it.get("media");
    return { index: i, id: m.get("id"), label: m.get("label") || m.get("data")?.label || `Scene ${i + 1}`, kind: m.get("class"), thumb: m.get("thumbnailUrl") };
  });
}

export const currentIndex = (t) => playlist(t).get("selectedIndex");
export const goTo = (t, i) => t.setMediaByIndex(i);

export function panoPlayer(t) {
  const pl = playlist(t);
  const pp = pl.get("items")[pl.get("selectedIndex")]?.get("player");
  return pp && pp.get("class") === "PanoramaPlayer" ? pp : null;
}

export function setNativeHotspots(t, on, hidden = []) {
  (playlist(t).get("items") || []).forEach((it) => {
    (it.get("media").get("overlays") || []).forEach((o) => {
      if (o.get("class") === "HotspotPanoramaOverlay") o.set("enabled", on && !hidden.includes(o.get("id")));
    });
  });
}

export function nativeHotspots(t, index) {
  const it = (playlist(t).get("items") || [])[index];
  if (!it) return [];
  return (it.get("media").get("overlays") || []).filter((o) => o.get("class") === "HotspotPanoramaOverlay").map((o) => {
    const im = (o.get("items") || [])[0];
    const ar = (o.get("areas") || [])[0];
    const tip = ar?.get("toolTip") || "";
    const label = tip || (o.get("data")?.label || "").replace(/^Go to /, "");
    return im && Number.isFinite(im.get("yaw")) ? { id: o.get("id"), label, nav: !!o.get("data")?.hasPanoramaAction, yaw: +im.get("yaw"), pitch: +(im.get("pitch") || 0) } : null;
  }).filter(Boolean);
}

export function project(pp, yaw, pitch) {
  const c = dir(pp.get("yaw"), pp.get("pitch"));
  const d = dir(yaw, pitch);
  if (c[0] * d[0] + c[1] * d[1] + c[2] * d[2] < 0.25) return null;
  const s = pp.getScreenPosition(yaw, pitch);
  return s && Number.isFinite(s.x) ? s : null;
}

export function unproject(pp, x, y, w, h) {
  const f = w / 2 / Math.tan(((pp.get("actualHFOV") || pp.get("hfov")) * RAD) / 2);
  const dx = x - w / 2;
  const dy = h / 2 - y;
  const p0 = pp.get("pitch") * RAD;
  const yy = dy * Math.cos(p0) + f * Math.sin(p0);
  const zz = -dy * Math.sin(p0) + f * Math.cos(p0);
  let yaw = pp.get("yaw") + Math.atan2(dx, zz) / RAD;
  let pitch = Math.atan2(yy, Math.hypot(dx, zz)) / RAD;
  for (let k = 0; k < 4; k++) {
    const s = pp.getScreenPosition(yaw, pitch);
    if (!s || !Number.isFinite(s.x)) break;
    yaw += (x - s.x) / f / RAD;
    pitch -= (y - s.y) / f / RAD;
  }
  return { yaw: +yaw.toFixed(2), pitch: +pitch.toFixed(2) };
}
